











































































































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ConfirmModal extends Vue {
  @Prop() private title!: string
  @Prop() private message!: string

  private doSave () {
    this.$emit('do-save')
  }
  private closeModal () {
    this.$emit('close-modal')
  }
}
